import { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  FxImageContainer, // eslint-disable-line no-unused-vars
  FxActionCard, // eslint-disable-line no-unused-vars
  FxBreadcrumbs, // eslint-disable-line no-unused-vars
  FxPageContainer, // eslint-disable-line no-unused-vars
} from 'axp-fx-common';
import { browserHistory } from '@americanexpress/one-app-router';
import {
  digitalAssetsActions,
  pageInstructions,
} from './manageDigitalAssetsInitData';
import labels from '../../constants/labels';
import { dispatchUpdatedPageInstructions } from '../../redux/dispatchers/help/help';
import { routes } from '../../constants/paths';
import PageHeader from '../Common/Headers/PageHeader'; // eslint-disable-line no-unused-vars
import ActionModal from '../Common/ActionContainer/ActionModal'; // eslint-disable-line no-unused-vars
import { manageDigitalAssetsBreadcrumbs } from '../../constants/breadcrumbs';

const ManageDigitalAssets = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [componentPath, setComponentPath] = useState(null);

  const handleTertiaryButtonClick = (modalProp, path) => {
    setModalData(modalProp);
    setShowModal(true);
    setComponentPath(path);
  };

  const navigatePath = (pathname) => {
    browserHistory.push({
      pathname,
    });
  };

  // update help menu content
  const dispatch = useDispatch();
  dispatch(dispatchUpdatedPageInstructions(pageInstructions));

  return (
    <>
      <FxPageContainer>
        <FxBreadcrumbs breadcrumbItems={manageDigitalAssetsBreadcrumbs} />
        <PageHeader headerText={labels.MANAGE_DIGITAL_ASSETS} />
      </FxPageContainer>

      <FxImageContainer containerHeading={labels.AMEX_OWNED_ASSETS}>
        <FxActionCard
          {...digitalAssetsActions.fxAccount}
          onPrimaryButtonClick={() => navigatePath(routes.manageDigitalAssetsFxAccount)}
          onTertiaryButtonClick={() => handleTertiaryButtonClick(
              digitalAssetsActions.fxAccount.modalProp,
              routes.manageDigitalAssetsFxAccount
            )}
        />
        {showModal && (
          <ActionModal
            modalProp={modalData}
            componentPath={componentPath}
            toggleModal={() => setShowModal(false)}
          />
        )}
      </FxImageContainer>
    </>
  );
};

export default ManageDigitalAssets;
